import './styles/Index.scss';
import './styles/theme.scss';

import { ConfigProvider } from 'antd';
import ruRU from 'antd/lib/locale/ru_RU';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import { NotificationThemeProvider } from '@/components/Client/shared/config/notification-theme-provider';

import { App } from './App';
import './i18n';
import './lib/echarts.config';
import { store } from './store/index';

// Тема для статических antd-методов (notification/message/Modal): они рендерятся
// вне дерева, поэтому оборачиваем их холдер. Тема активна только когда открыт
// клиентский модуль (сигнал из ClientLayout), иначе — дефолт antd.
ConfigProvider.config({
  holderRender: (children) => (
    <NotificationThemeProvider>{children}</NotificationThemeProvider>
  )
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const isProduction = process.env.NODE_ENV === 'production';

// Service worker (PWA) регистрируется только внутри клиентского модуля —
// см. src/components/Client/shared/pwa/register-sw.ts. Глобально не регистрируем:
// PWA доступна только для Client.

const helmetContext = {};

root.render(
  <Provider store={store}>
    <ConfigProvider locale={ruRU}>
      <BrowserRouter>
        <HelmetProvider context={helmetContext}>
          <Helmet
            titleTemplate={`${isProduction ? 'Allur Finance - ' : ''}%s`}
            defaultTitle={isProduction ? 'Allur Finance' : ''}
            meta={
              isProduction
                ? [
                    {
                      name: 'description',
                      content: 'Крупнейшая автомобильная компания Казахстана'
                    }
                  ]
                : []
            }
            link={
              isProduction
                ? [
                    {
                      rel: 'icon',
                      type: 'image/png',
                      href: '/icons/favicon-96x96.png',
                      sizes: '96x96'
                    },
                    {
                      rel: 'icon',
                      type: 'image/svg+xml',
                      href: '/icons/favicon.svg'
                    },
                    { rel: 'shortcut icon', href: '/icons/favicon.ico' },
                    {
                      rel: 'apple-touch-icon',
                      sizes: '180x180',
                      href: '/icons/apple-touch-icon.png'
                    },
                    {
                      rel: 'apple-mobile-web-app-title',
                      content: 'Allur Finance'
                    },
                    { rel: 'preconnect', href: 'https://storage.allur-fin.kz' }
                  ]
                : [
                    { rel: 'icon', href: 'data:image/png;base64,iVBORw0KGgo=' }, // Пустое изображение
                    {
                      rel: 'preconnect',
                      href: 'https://storage.delfi-test-zone.kz'
                    }
                  ]
            }
          />

          <App />
        </HelmetProvider>
      </BrowserRouter>
    </ConfigProvider>
  </Provider>
);

// If you want to start measuring performance in your admin, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
